import Masonry from 'masonry-layout';
import PageComponent from '../../common/component/page-component';

const names = {
	itemsAttr: 'items',
	itemAttr: 'item',
	gutterVar: '--gutterSize',
	masonryLayoutEnabledVar: '--masonryLayoutEnabled',
};

class MasonryLayout extends PageComponent {
	prepare() {
		this.style = getComputedStyle(this.element);
		this.layout = null;
		this.listeners.resize = this.events.on(window, 'window:resize', this.onResize.bind(this));
		this.update();
	}

	onResize(event) {
		requestAnimationFrame(() => this.update());
	}

	update() {
		const enabled = !!parseInt(this.style.getPropertyValue(names.masonryLayoutEnabledVar), 10);
		if (enabled) {
			if (!this.layout) {
				this.layout = new Masonry(this.element.querySelector(this.dataSelector(names.itemsAttr)), {
					itemSelector: this.dataSelector(names.itemAttr),
					percentPosition: true,
					gutter: parseInt(this.style.getPropertyValue(names.gutterVar), 10),
				});
			}
		} else {
			if (this.layout) {
				this.layout.destroy();
				this.layout = null;
			}
		}
	}
}

export default MasonryLayout;
